// 📄 nexusAccionesService.ts
// Ejecuta una acción de Nexus AI que el usuario CONFIRMÓ en la tarjeta del
// chat (N4, 2026-10-27). La propuesta la arma el servidor (ver
// functions/services/nexusAcciones.js) y acá se ejecuta con los mismos
// servicios que usa la app a mano y con los permisos del propio usuario
// (firestore.rules), así que también salen los mismos correos de aviso.
import { getProject } from './projectService.ts';
import { createTarea, updateTareaEstado } from './tareaService.ts';
import { createIncidente } from './incidenteService.ts';
import { createRegistro } from './registroHorasService.ts';

export type TipoAccionNexus = 'crearTarea' | 'completarTarea' | 'crearIncidente' | 'registrarHoras';

export interface AccionNexus {
  tipo: TipoAccionNexus;
  projectId: string;
  proyectoNombre: string;
  datos: Record<string, any>;
}

export const ETIQUETA_ACCION: Record<TipoAccionNexus, { boton: string; hecho: string; ruta: string }> = {
  crearTarea: { boton: 'Crear tarea', hecho: 'Tarea creada', ruta: 'tareas' },
  completarTarea: { boton: 'Completar tarea', hecho: 'Tarea completada', ruta: 'tareas' },
  crearIncidente: { boton: 'Crear incidente', hecho: 'Incidente creado', ruta: 'incidentes' },
  registrarHoras: { boton: 'Registrar horas', hecho: 'Horas registradas', ruta: 'horas' }
};

export const ejecutarAccionNexus = async (
  accion: AccionNexus,
  usuario: { uid: string; email: string; nombre: string }
): Promise<void> => {
  const { tipo, projectId, datos } = accion;
  const proyecto = await getProject(projectId);
  if (!proyecto) throw new Error('El proyecto ya no existe o no tienes acceso.');

  switch (tipo) {
    case 'crearTarea':
      await createTarea(
        projectId, proyecto.nombre,
        { titulo: datos.titulo, descripcion: datos.descripcion || '', asignadoA: datos.asignadoA, fechaLimite: datos.fechaLimite, seccionRelacionada: '', hitoId: datos.hitoId || '' },
        proyecto.miembros, usuario.uid, usuario.nombre, datos.hitoNombre || ''
      );
      return;
    case 'completarTarea':
      await updateTareaEstado(projectId, datos.tareaId, 'Completada', datos.hitoId || '');
      return;
    case 'crearIncidente':
      await createIncidente(projectId, {
        titulo: datos.titulo,
        descripcion: datos.descripcion,
        reportadoPorNombre: usuario.nombre,
        reportadoPorEmail: usuario.email,
        fase: 'Soporte',
        solucionRelacionada: '',
        ambiente: datos.ambiente,
        prioridad: datos.prioridad,
        asignadoA: datos.asignadoA || '',
        canal: ''
      }, [], proyecto.miembros);
      return;
    case 'registrarHoras':
      await createRegistro(projectId, usuario.uid, {
        fecha: datos.fecha,
        solucionRelacionada: datos.solucionRelacionada || '',
        horas: Number(datos.horas),
        huboSesion: false,
        asistentes: '',
        cambiosRealizados: datos.cambiosRealizados || '',
        conclusiones: ''
      });
      return;
    default:
      throw new Error('Acción desconocida.');
  }
};
